<script setup>
import {computed} from 'vue'
import PageContentMobileContent from './PageContentMobileContent'
import Button from '@/common/Button.vue'
import api from '@/services/api'
import {usePageContentDataStore} from '@/stores/pageContentData'
import {useModalsStore} from '@/stores/modals'

const props = defineProps({
    pageId: Number,
    contentAreas: Array,
    contentArea: String,
    contentAreaFirst: Boolean,
    contentAreaLast: Boolean,
})

const pageContentDataStore = usePageContentDataStore()
const modalsStore = useModalsStore()

// Computed properties
const items = computed(() => {
    return pageContentDataStore.items.filter((obj) => {
        return (
            obj.pageId === props.pageId &&
            obj.contentArea === props.contentArea
        )
    })
})

// Methods
const showAddContentModal = () => {
    modalsStore.show({
        componentName: 'AddContentModal',
        obj: {
            onSelect: async (obj) => {
                try {
                    await api.post('api/save-content-to-page', {
                        pageId: props.pageId,
                        contentId: obj.contentId,
                        contentArea: props.contentArea
                    })
                    await pageContentDataStore.init()
                } catch (err) {
                    // Handle error if needed
                }
            }
        }
    })
}
</script>

<template>
    <div class="card mb-3">
        <div class="card-header py-1 pe-2 d-flex align-items-center">
            <span class="flex-fill">{{ contentArea }}</span>

            <Button class="btn-sm" @click="showAddContentModal">
                <i class="bi-plus-lg"/>
            </Button>
        </div>

        <ul v-if="items.length" class="list-group list-group-flush">
            <PageContentMobileContent v-for="(item, index) in items" :key="item.id" :content-areas="contentAreas"
                                      :content-area="contentArea" :content-area-first="contentAreaFirst"
                                      :content-area-last="contentAreaLast" :content-index="index"
                                      :content-last="index === items.length - 1" :page-content-link-id="item.id"/>
        </ul>
    </div>
</template>

<style scoped>
.card-header:last-child {
    border-bottom: none; /* Remove the double width bottom border */
}
</style>